/* eslint-disable */
import React from 'react';
import { ImageSelect } from '../_shared/ImageSelect';

const OPTIONS = [{ id: 'oval' }, { id: 'round' }, { id: 'rectangle' }, { id: 'square' }, { id: 'notSure' }, { id: 'triangle' }];

function Page() {
  return (
    <ImageSelect
      page="hairstyle-face-shape"
      progress={31}
      field="hairstyleFaceShape"
      setter="setHairstyleFaceShape"
      ns="hairstyleFaceShape"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
